<template>
  <div id="app" class="container-fluid p-0">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  computed: {
  }
}
</script>

<style>
</style>
